module.exports = __webpack_public_path__ + "static/img/mCsBanner@2x.e4f0cad1.png";